export const URL = {
  root: "/",
  login: "/login",
  selectMunicipality: "/gemeinde-auswaehlen",
  zoningPlanLegal: "/rechtskraeftiger-zonenplan",
  zoningPlanLegalCalculation: "/rechtskraeftiger-zonenplan/bauzonenkapazitaet",
  zoningPlanLegalUndevelopedBuildingZones:
    "/rechtskraeftiger-zonenplan/unueberbaute-bauzonen",
  zoningPlanLegalSiteSpecificValues: "/rechtskraeftiger-zonenplan/kennwerte",
  zoningPlanDraft: "/zonenplan-mit-ohne-vorwirkung",
  zoningPlanDraftUpload: "/zonenplan-mit-ohne-vorwirkung/upload",
  zoningPlanDraftCalculation:
    "/zonenplan-mit-ohne-vorwirkung/bauzonenkapazitaeten-vergleichen",
  zoningPlanDraftSiteSpecificValues: "/zonenplan-mit-ohne-vorwirkung/kennwerte",
  help: "/hilfe",
  error: "/fehler",
};

export const MUNICIPALITY_STORAGE_KEY = "LUBAT_SELECTED_MUNICIPALITY";

export const LINKS = {
  [URL.zoningPlanLegalCalculation]: "Bauzonenkapazität",
  [URL.zoningPlanLegalUndevelopedBuildingZones]: "Unüberbaute Bauzonen",
  [URL.zoningPlanLegalSiteSpecificValues]: "Kennwerte",
  [URL.zoningPlanDraft]: "Hilfe",
  [URL.zoningPlanDraftUpload]: "Zonenplan hochladen",
  [URL.zoningPlanDraftSiteSpecificValues]: "Kennwerte",
  [URL.zoningPlanDraftCalculation]: "Bauzonenkapazitäten vergleichen",
};
